/**
 * @file 日志存储配置开关 true 启用 false 关闭
 * @author luyinpeng
 * @date 2026-04-23
 * @description 日志存储配置开关，用于控制是否启用日志存储
 */

export function isApiLogEnabled(): boolean {
    return false;
}
